<template>
    <l-tooltip v-if="alarm">
        <ul class="list-unstyled list-inline d-flex justify-content-between">
            <li class="list-inline-item">
                <span class="text-nowrap">{{ alarm.date }}</span>
            </li>
            <li class="list-inline-item">
                <BatteryDisplay :battery="alarm.battery" />
            </li>
        </ul>
        <ul class="list-unstyled list-inline d-flex justify-content-between">
            <li class="list-inline-item">
                {{ alarm.speed }} km/h
            </li>
            <li class="list-inline-item">
                GPS : <GPSDisplay :gps="alarm.levelGPS"/>
            </li>
            <li class="list-inline-item">
                GSM : <GSMDisplay :gsm="alarm.levelGSM"/>
            </li>
        </ul>
        <div class="fw-bold">Adresse :</div>
        <div>{{ alarm.address }}</div>
        <div>
            <AlarmDisplay :alarm="alarm" />
        </div>
    </l-tooltip>
</template>

<script>
import AlarmDisplay from '@/components/display/AlarmDisplay.vue'
import BatteryDisplay from '@/components/display/BatteryDisplay.vue'
import GPSDisplay from '@/components/display/GPSDisplay.vue'
import GSMDisplay from '@/components/display/GSMDisplay.vue'
import { LTooltip } from "@vue-leaflet/vue-leaflet";

export default {
    props: ['alarm'],
    components: {
        LTooltip,
        BatteryDisplay,
        GPSDisplay,
        GSMDisplay,
        AlarmDisplay
    }
}
</script>